/* «Norge er det perfekte testlandet»: bildet åpner seg fra et lite vindu til
 * full skjerm mens seksjonen ruller inn, og teksten kommer av seg selv når
 * seksjonen er godt inne. Ingenting pinnes, så siden ruller som vanlig.
 *
 * Med «reduser bevegelse» hopper vi over hele greia. Da står bildet i full
 * bredde fra start, slik CSS-en har det. */

import gsap from 'gsap';
import { $, mindreBevegelse } from '../kjerne/verktoy.js';

export function startTestland() {
  const seksjon = $('#testland');
  if (!seksjon || mindreBevegelse.matches) return;

  const bilde = $('.testland-bilde', seksjon);

  /* Bildet følger rullingen og er helt åpent idet seksjonen fyller skjermen. */
  gsap.timeline({
    scrollTrigger: { trigger: seksjon, start: 'top 90%', end: 'top top', scrub: .6 },
  })
    .fromTo(bilde,
      { clipPath: 'inset(22% 30% 22% 30%)' },
      { clipPath: 'inset(0% 0% 0% 0%)', ease: 'power1.out', duration: 1 })
    .fromTo($('img', bilde),
      { scale: 1.35 },
      { scale: 1.02, ease: 'power1.out', duration: 1 }, 0);

  /* Teksten er ikke bundet til rullingen: den spilles av én gang. */
  gsap.timeline({ scrollTrigger: { trigger: seksjon, start: 'top 45%', once: true } })
    .fromTo(seksjon.querySelectorAll('.tegn'),
      { yPercent: 130 },
      { yPercent: 0, stagger: .02, ease: 'expo.out', duration: 1 })
    .fromTo(seksjon.querySelectorAll('.etikett, .testland-brod, .testland-merke'),
      { y: 24, opacity: 0 },
      { y: 0, opacity: 1, stagger: .08, duration: .8, ease: 'expo.out' }, .15);
}
